import React, { useEffect, useState } from "react";
import GameItem from "../mui/game_tem/GameItem";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino.js";
import { useDispatch } from "react-redux";
import { setBonusGames } from "../../store/gamesSlice.js";
import ShowContainer from "../mui/ShowContainer.jsx";
import LoaderContainer from "../mui/loader_container/LoaderContainer.jsx";
import NoGames from "../mui/games_items/NoGames.jsx";

export default function BonusGames() {
  const dispatch = useDispatch();
  const bonusProviderId = useAppSelector((state) => state.games.bonusProvider?.id);
  const games = useAppSelector((state) => state.games.bonusGames);
  const gamesLength = games.length;

  const [loader, setLoader] = useState(false);
  const [noGames, setNoGames] = useState(false);

  useEffect(() => {
    if (gamesLength || !bonusProviderId) {
      setLoader(false);
      return;
    }

    setLoader(true);
    API_CASINO.list
      .providerGames({ providerId: +bonusProviderId })
      .then((e) => {
        const list = e.data.list;
        dispatch(setBonusGames(list));
      })
      .catch(console.error)
      .finally(() => {
        setLoader(false);
        setNoGames(true);
      });
  }, [bonusProviderId, gamesLength]);

  return (
    <LoaderContainer center loader={loader}>
      <ShowContainer
        condition={games.length}
        plug={
          <ShowContainer condition={noGames}>
            <NoGames />
          </ShowContainer>
        }>
        <div className="games__games">
          {games.map((el, indx) => (
            <GameItem
              key={el.game_id + "_" + indx}
              currentGame={el}
              url="/bonus_game/"
              name={el.name}
              image={el.image}
            />
          ))}
        </div>
      </ShowContainer>
    </LoaderContainer>
  );
}
